/* @flow */
import cx from 'classnames';
import ChatMessage from 'entities/ChatMessage';
import CurrentUser from 'auth/CurrentUser';
import HumanArray from 'components/HumanArray.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Reaction from 'entities/Reaction';
import ShortcodeEmoji from 'components/ShortcodeEmoji.jsx';
import Tooltip from 'components/Tooltip.jsx';

import React from 'react';

import './styles/MessageReaction.scss';

type Props = {
  message: ChatMessage,
  reaction: Reaction,
};

const replaceYourNameWithTheWordYouIn = names => {
  return names.map(name => {
    return name === CurrentUser.getUser().getName() ? 'You' : name;
  });
};

class MessageReaction extends React.Component {
  props: Props;

  hasBeenSelectedByCurrentUser() {
    return this.props.reaction.getUserUuids().includes(CurrentUser.getUserUuid());
  }

  toggleReaction = () => {
    const { reaction, message } = this.props;
    if (this.hasBeenSelectedByCurrentUser()) {
      message.removeReaction(reaction.getName());
    } else {
      message.addReaction(reaction.getName());
    }
  };

  render() {
    const { reaction } = this.props;

    const tooltip = (
      <Tooltip>
        <span>
          <HumanArray
            sample={replaceYourNameWithTheWordYouIn(reaction.getUserNames())}
            total={reaction.getCount()}
          />
        </span>
      </Tooltip>
    );

    return (
      <LayerTrigger
        trigger={['hover', 'focus']}
        layer={tooltip}
        placement="bottom">
        <div
          className={cx('MessageReaction', {
            'MessageReaction-selfReacted': this.hasBeenSelectedByCurrentUser(),
          })}
          onClick={this.toggleReaction}>
          <ShortcodeEmoji text={reaction.getEmojiCode()} />
          <div className="MessageReaction-count">{reaction.getCount()}</div>
        </div>
      </LayerTrigger>
    );
  }
}

export default MessageReaction;



// WEBPACK FOOTER //
// ./src/chat/components/MessageReaction.jsx